import { createFileRoute } from "@tanstack/react-router";

import { KennisbankArticlePage } from "@/features/kennisbank";

export const Route = createFileRoute("/_authenticated/kennisbank/$slug")({
	component: KennisbankArticlePage,
});
